import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { fadeAnimation, listInAnimation } from 'src/app/app.animation';
import { ApiService, GetData } from 'src/app/service/basic/api.service';
import { LanguageService } from 'src/app/service/language/language.service';
import { RegexService } from 'src/app/service/util/regex.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  animations: [fadeAnimation, listInAnimation]
})
export class CompanyComponent implements OnInit {

  searchParams:GetData.SearchCompanyParams = {
    search_text: ""
  }
  companyResult:GetData.SearchCompanyResult = null;
  selectedCompanyItem:GetData.SearchCompanyItem = null;

  constructor(
    private _modal: ModalController,
    private api: ApiService,
    public regex: RegexService,
    public lang: LanguageService
  ) { }

  ngOnInit() {}

  async iptSearchEnter() {
    this.companyResult = await this.api.GetData.search_company(this.searchParams, {
      loading: "업체 검색 중"
    });
  }
  async btnNextClick() {
    this._modal.dismiss({ 
      company_id: this.selectedCompanyItem.company_id,
      company_name: this.selectedCompanyItem.company_name
     })
  }
}
